import { makeAutoObservable } from "mobx";

export default class ClientMemuStore {
  currentMemu: string = "dashboard";

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentMenu = (temp: string | undefined) => {
    if (temp !== undefined) {
      this.currentMemu = temp;
    }
  };
}
